/**
 * Asynchronously loads the components for Student Placement Drives
 */

import { lazyLoad } from 'utils/loadable';

export const StudentPlacementDashboard = lazyLoad(
  () => import('./PlacementDashboard'),
  module => module.StudentPlacementDashboard,
);

export const StudentDriveDetails = lazyLoad(
  () => import('./DriveDetails'),
  module => module.StudentDriveDetails,
);

export const StudentJobDetails = lazyLoad(
  () => import('./JobDetails'),
  module => module.StudentJobDetails,
);